/**
 * Application Messages (Greek)
 * Centralized message strings for the application
 */

export const MESSAGES = {
  // Errors
  ERROR_READING_FILE: 'Σφάλμα κατά την ανάγνωση του αρχείου Excel. Βεβαιωθείτε ότι είναι έγκυρο αρχείο .xlsx.',
  ERROR_PROCESSING_VEHICLES: 'Σφάλμα κατά την επεξεργασία των οχημάτων. Παρακαλώ δοκιμάστε ξανά.',
  ERROR_DOWNLOAD_TEMPLATE: 'Αποτυχία λήψης προτύπου. Παρακαλώ δοκιμάστε ξανά.',
  ERROR_INVALID_FILE: 'Παρακαλώ ανεβάστε ένα αρχείο Excel (.xlsx)',

  // Success
  SUCCESS_PROCESSING_COMPLETE: 'Η Επεξεργασία Ολοκληρώθηκε!',
  SUCCESS_VEHICLES_PROCESSED: 'Επεξεργάστηκαν επιτυχώς',

  // Info
  INFO_PROCESSING: 'Επεξεργασία οχημάτων...',
  INFO_PROCESSING_NOTE: 'Αυτό μπορεί να πάρει λίγα λεπτά',
  INFO_VEHICLES_LOADED: 'όχημα φορτώθηκαν',
  INFO_VEHICLES_LOADED_PLURAL: 'οχήματα φορτώθηκαν',

  // Instructions
  INSTRUCTIONS_TITLE: 'Πώς να Χρησιμοποιήσετε τον Έλεγχο Ασφάλισης',
  INSTRUCTIONS_SUBTITLE: 'Ακολουθήστε αυτά τα απλά βήματα για να επαληθεύσετε την ασφάλιση οχημάτων',

  // Buttons
  BTN_CHECK_INSURANCE: 'Έλεγχος Ασφάλισης',
  BTN_DOWNLOAD_RESULTS: 'Λήψη Αποτελεσμάτων',
  BTN_NEW_UPLOAD: 'Νέο Ανέβασμα',
  BTN_DOWNLOAD_TEMPLATE: 'Κατέβασμα Κενού Προτύπου',
  BTN_START: 'Ξεκινήστε',
  BTN_BROWSE_FILES: 'Αναζήτηση Αρχείων',
  BTN_VIEW_TABLE: 'Προβολή Πίνακα',
  BTN_INSTRUCTIONS: 'Οδηγίες',

  // Status
  STATUS_PENDING: 'Εκκρεμεί',
  STATUS_INSURED: 'ΑΣΦΑΛΙΣΜΕΝΟ',
  STATUS_UNINSURED: 'ΑΝΑΣΦΑΛΙΣΤΟ',
  STATUS_NOT_FOUND: 'ΔΕΝ ΒΡΕΘΗΚΕ',
  STATUS_ERROR: 'ΣΦΑΛΜΑ',
  STATUS_FAILED: 'ΑΠΟΤΥΧΙΑ',
} as const;

export type MessageKey = keyof typeof MESSAGES;
